import Vue from "vue";
import VueMeta from 'vue-meta'
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify/index";
import i18n from "./plugins/i18n";
import Vuelidate from "vuelidate"
import "@/plugins/dayjs";
import ProperDate from "./common/proper.date.filter";
import ShowDate from "./common/show.date.filter";
import DateOnly from "./common/date.only.filter";
import { CONFIG } from "./common/config";
import "@fortawesome/fontawesome-free/css/all.css";

// Import analytics library
import VueGtag from "vue-gtag";

/**
* Globally register all `_base`-prefixed components
*/
import "./helpers/globals.js"

Vue.config.productionTip = false;

Vue.use(VueMeta)

Vue.use(Vuelidate);

Vue.filter("properDate", ProperDate);
Vue.filter("ShowDate", ShowDate);
Vue.filter("DateOnly", DateOnly);

Vue.use(VueGtag, {
    config: {
        id: CONFIG.analytics_id
    }
})


new Vue({
    name: "Hma",
    router,
    store,
    vuetify,
    i18n,
    render: (h) => h(App),
}).$mount("#app");
